import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';

import Seo from '../components/seo';
import GridProductos from '../components/producto/gridProductos';
import Layout from '../components/layout';
import {
    getCategoriasPorComercio,
    getProductosPorCatLimit,
    getProductosPorQuery
} from '../services/branch';
import SkeletonProds from '../components/skeletons/grid-prod';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ModalProd from '../components/producto/modalProd';
import { useParams } from 'react-router-dom';

const ProductosPorCategoria = () => {
    const { t } = useTranslation();
    const shop = useSelector((store) => store.shop);
    const carStore = useSelector((store) => store.car);
    const [Categorias, setCategorias] = useState([]);
    const [CategoriaSeleccionada, setCategoriaSeleccionada] = useState(null);
    const [FilterCategorias, setFilterCategorias] = useState([]);
    const [ProductosF, setProductosF] = useState(null);
    const [Loading, setLoading] = useState(false);
    const controladorTiempo = useRef(null);
    const { itemid } = useParams();
    useEffect(() => {
        if (shop.branchActive) {
            // console.log(shop.infoShop.local_currency);
            getCats();
        }
    }, [shop.branchActive]);

    const getCats = async () => {
        let cats = await getCategoriasPorComercio(
            shop.config.ShopCurrency,
            shop.config.CompanyID,
            shop.config.BranchID
        );
        // console.log(cats.data.data);
        if (cats.status === 200) {
            setFilterCategorias(cats.data.data);
            setCategorias(cats.data.data);
        }
    };
    useEffect(() => {
        if (CategoriaSeleccionada) {
            setFilterCategorias(
                Categorias.filter((n) => n.id === CategoriaSeleccionada)
            );
        } else {
            setFilterCategorias(Categorias);
        }
    }, [CategoriaSeleccionada]);

    useEffect(() => {
        if (Categorias.length > 0 && itemid) {
            const find = Categorias.find((n) => {
                // console.log(
                //     n.name.toLocaleLowerCase(),
                //     itemid.replaceAll('-', ' ').toLocaleLowerCase()
                // );
                return (
                    n.name.toLocaleLowerCase() ===
                    itemid.replaceAll('-', ' ').toLocaleLowerCase()
                );
            });
            if (find) {
                setCategoriaSeleccionada(find.id);
            }
        }
    }, [Categorias]);

    const inputFilter = (e) => {
        clearTimeout(controladorTiempo.current);
        controladorTiempo.current = setTimeout(() => {
            changeText(e.target.value);
        }, 500);
    };
    const changeText = async (q) => {
        setCategoriaSeleccionada(null);
        if (q.trim() !== '') {
            setLoading(true);
            let prodFilters = await getProductosPorQuery(
                shop.config.ShopCurrency,
                shop.config.CompanyID,
                q,
                shop.config.BranchID
            );
            setLoading(false);
            console.log(prodFilters.data);
            setProductosF(prodFilters.data);
        } else {
            setProductosF(null);
        }
    };
    return (
        <Layout>
            <Seo
                title={`${
                    shop.config && shop.config.ShopName
                } - Lista de categorias`}
            />
            <section id="ListaCategorias" className="container paddingY70">
                <div className="topCategorias d-flex justify-content-between flex-column-reverse flex-lg-row">
                    <div className="filters">
                        {Categorias.length > 1 && (
                            <button
                                className={
                                    CategoriaSeleccionada === null &&
                                    ProductosF === null
                                        ? 'active'
                                        : ''
                                }
                                onClick={() => {
                                    setProductosF(null);
                                    setCategoriaSeleccionada(null);
                                }}
                            >
                                <span>{t('Todas')}</span>
                            </button>
                        )}
                        {Categorias.map((c) => (
                            <button
                                key={c.id}
                                className={
                                    CategoriaSeleccionada === c.id
                                        ? 'active'
                                        : ''
                                }
                                onClick={() => {
                                    setProductosF(null);
                                    setCategoriaSeleccionada(c.id);
                                }}
                            >
                                <span>{c.name} </span>
                            </button>
                        ))}
                    </div>
                    <div className="search">
                        <div className="_wrapinput icon-l">
                            <input
                                type="text"
                                placeholder={t('BuscarProductos')}
                                onChange={inputFilter}
                            />
                            <i className="icon-lupa"></i>
                        </div>
                    </div>
                </div>
                {Loading ? (
                    <>
                        <SkeletonProds />
                    </>
                ) : (
                    <>
                        {ProductosF === null ? (
                            FilterCategorias.map((c, idx) => {
                                return (
                                    <Categoria
                                        key={idx}
                                        categoria={c}
                                        branchId={shop.config.BranchID}
                                        companyId={shop.config.CompanyID}
                                        currency={shop.config.ShopCurrency}
                                    />
                                );
                            })
                        ) : (
                            <GridProductos productos={ProductosF} />
                        )}
                    </>
                )}
            </section>
            {carStore.productoActivo && (
                <ModalProd producto={carStore.productoActivo} />
            )}
        </Layout>
    );
};

export default ProductosPorCategoria;

const Categoria = ({ currency, categoria, branchId, companyId }) => {
    const [Productos, setProductos] = useState([]);
    const [LoadingProds, setLoadingProds] = useState(false);
    useEffect(() => {
        (async () => {
            setLoadingProds(true);
            let prods = await getProductosPorCatLimit(
                currency,
                companyId,
                categoria.id,
                branchId
            );
            // console.log(prods)
            if (prods.status === 200) {
                setProductos(prods.data.data);
            }
            setLoadingProds(false);
        })();
    }, [categoria]);

    return (
        <div className="categoriaResumen" key={categoria.id}>
            <div className="top d-flex justify-content-between">
                <h2 className="textTitle">{categoria.name}</h2>
                {/* <Link
                    to={categoria.id.toString()}
                    className="d-flex align-items-center"
                >
                    <span>Ver todos</span>
                    <i className="icon-angle-left reflect ml-2"></i>
                </Link> */}
            </div>
            {LoadingProds ? (
                <SkeletonProds />
            ) : (
                <GridProductos productos={Productos} />
            )}
            <div className="mb-3" />
        </div>
    );
};
